export enum ServiceViewMutationTypes {
  SET_PORTFOLIO_DATA = 'SET_PORTFOLIO_DATA',
}
